import * as THREE from 'three';
import Sizes from './Utils/Sizes';
import Time from './Utils/Time';
import Camera from './Camera';
import Renderer from './Renderer';
import Debug from './Utils/Debug';
import Resources from './Utils/Resources';
import sources from './sources';
import World from './World/World';
import PostProcessor from './World/PostProcessor';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import AudioManager from './Audio/AudioManager';
import gsap from 'gsap';
let experience = null;
export default class Experience {

    constructor(canvas) {

        if (experience) {
            return experience;
        }

        experience = this;
        window.experience = this;
        this.canvas = canvas;


        this.debug = new Debug();
        this.sizes = new Sizes();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.cssScene = new THREE.Scene(); // CSS3D场景
        this.resources = new Resources(sources);
        // this.stats = new Stats();

        // Post-processing setup
        // Triger when the experience is created, renderer is ready
        this.postProcessor = null;
        // 监听资源加载完成事件
        // 资源加载完成后，创建后处理器
        // 这里假设PostProcessor是一个处理后期效果的类
        this.resources.on('ready', () => {
            this.world = new World();

            this.camera = new Camera();
            this.renderer = new Renderer();

            // this.stats.showPanel(0); // 0: fps, 1: ms, 2: memory
            // document.body.appendChild(this.stats.dom);
            this.scene.background = new THREE.Color(0x101010); // 设置背景颜色为黑色
            this.postProcessor = new PostProcessor();


            this.setupAudioSources().then(() => {
                // 加载完毕
                this.showPlayButton(); // 显示播放按钮
                this.onLoadingComplete(); // 调用加载完成方法
            })
        });

        console.log("The code for this project is not publicly available. If you have any technical questions about it, feel free to contact me or refer to Henry Heffernan’s project: https://github.com/henryjeff/portfolio-website/tree/master")


        this.sizes.on('resize', () => {
            this.resize();
        });

        this.time.on('tick', () => {
            this.update();
        });
    }


    isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
            ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0);
    }

    setupMobileOrientation() {
        // 请求横屏锁定（如果支持）
        const lockOrientation = () => {
            if (screen.orientation && screen.orientation.lock) {
                screen.orientation.lock('landscape').catch((err) => {
                    console.log('Orientation lock not supported or permission denied:', err);
                });
            } else if (screen.lockOrientation) {
                // 旧版API支持
                screen.lockOrientation('landscape');
            } else if (screen.mozLockOrientation) {
                // Firefox支持
                screen.mozLockOrientation('landscape');
            } else if (screen.msLockOrientation) {
                // IE/Edge支持
                screen.msLockOrientation('landscape');
            }
        };

        // 监听屏幕方向变化
        const handleOrientationChange = () => {
            const orientationMessage = document.getElementById('orientation-message');
            if (orientationMessage) {
                if (window.innerHeight > window.innerWidth) {
                    // 竖屏
                    orientationMessage.classList.add('show');
                } else {
                    // 横屏
                    orientationMessage.classList.remove('show');
                    // 尝试锁定横屏
                    lockOrientation();
                }
            }
        };

        // 初始检查
        handleOrientationChange();

        // 监听方向变化
        window.addEventListener('orientationchange', handleOrientationChange);
        window.addEventListener('resize', handleOrientationChange);

        // 尝试立即锁定（需要用户交互后）
        const tryLock = () => {
            lockOrientation();
            // 移除事件监听器，只需要一次
            document.removeEventListener('click', tryLock);
            document.removeEventListener('touchstart', tryLock);
        };

        // 在用户首次交互时尝试锁定
        document.addEventListener('click', tryLock, { once: true });
        document.addEventListener('touchstart', tryLock, { once: true });
    }

    async setupAudioSources() {
        try {
            // 初始化 3D 音频管理器
            this.audioManager = new AudioManager(this.camera.instance, this.scene);
            await this.audioManager.createPositionalAudio(
                'computer-start',
                '/audio/xp_pirate_start.mp3',
                new THREE.Vector3(-1.0368, 3.4505, -2.2477), // 显示器位置
                {
                    loop: false,
                    volume: 0.7,
                    refDistance: 2,
                    maxDistance: 10,
                    rolloffFactor: 2
                }
            );

        } catch (error) {
            console.error('Failed to setup audio sources:', error);
        }
    }

    onLoadingComplete() {
        this.welcomeImage = document.createElement('img');
        this.welcomeImage.src = '/welcome_screen.png';
        // 占满屏幕
        this.welcomeImage.style.cssText = `
                position: fixed;
                top: 100px;
                left: 100px;
                width: calc(100% - 200px); /* 减去边距 */
                height: calc(100% - 200px); /* 减去边距 */
                pointer-events: none; /* 禁用交互，提升性能 */
                object-fit: cover;
                z-index: 1000; /* 确保在其他元素之上 */
            `;

        document.querySelector('#display-container').appendChild(this.welcomeImage);
        // 将portfolio-subtitle元素的内容替换为开始按钮
        document.querySelector('.progress-container').style.display = 'none'; // 隐藏加载器
        const subtitle = document.querySelector('.portfolio-subtitle')
        subtitle.innerHTML = 'Click anywhere to start / 點擊任意處開始';
        // 如果是移动设备，提示横屏使用
        if (this.isMobile()) {
            subtitle.innerHTML = 'Rotate to landscape, then tap to start / 請將設備橫屏，然後點擊開始';
            this.setupMobileOrientation();
        }
        subtitle.style.cssText = `
            border: 1px solid white;
            `;

        const loader = document.querySelector('#loader');
        loader.addEventListener('click', () => this.handleLoaderClick());
        loader.addEventListener('touchstart', () => this.handleLoaderClick());


    }
    // 点击防抖
    handleLoaderClick = () => {
        // 如果已经点击过，直接返回
        if (this.loaderClicked) return;
        // 设置点击状态为已点击
        this.loaderClicked = true;
        // 移除点击事件监听器，避免重复触发

        // 开始播放背景音乐
        this.startBackgroundMusic();
        this.audioManager.playPositionalAudio('computer-start')
        //display welcome screen image


        // 创建动画序列
        this.createTransitionAnimation();

        // 移除事件监听器
        const loader = document.querySelector('#loader');
        loader.removeEventListener('click', this.handleLoaderClick);

    }

    createTransitionAnimation() {
        const loader = document.querySelector('#loader');
        const progressContainer = document.querySelector('.progress-container');
        const portfolioSection = document.querySelector('.portfolio-section');

        // 立即隐藏进度条和其他元素
        progressContainer.style.display = 'none';
        portfolioSection.style.display = 'none';

        // 创建动画时间轴
        const tl = gsap.timeline({
            onComplete: () => {
                // 动画完成后隐藏 loader，显示 experience
                loader.style.display = 'none';
                // 显示欢迎图片
                setTimeout(() => {
                    this.welcomeImage.remove();
                }, 3000);
            }
        });

        // 1 背景渐渐模糊
        tl.to(loader, {
            duration: 2,
            backdropFilter: 'blur(2px)',
            ease: "power2.inOut"
        })


            // 2 背景继续模糊并变暗
            .to(loader, {
                duration: 2,
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(0,0,0,0.3)',
                ease: "power2.inOut"
            }, "-=1")


            // 3 整个 loader 淡出
            .to(loader, {
                duration: 2,
                opacity: 0,
                ease: "power2.inOut"
            }, "-=0.3");

    }
    async startBackgroundMusic() {
        try {
            // 加载环境音乐
            await this.audioManager.loadAmbientMusic('/audio/ambient-music.mp3');
            await this.audioManager.loadAmbientMusicWithBGM('/audio/childhood_compressed.mp3');
            // 尝试播放
            await this.audioManager.playAmbientMusic();
        } catch (error) {
            console.error('Failed to start background music:', error);
            this.showPlayButton();
        }
    }



    // 设置场景中的定位音频
    async setupPositionalAudio() {
        try {
            // 在显示器位置添加电脑运行声音
            await this.audioManager.createPositionalAudio(
                'computer-hum',
                '/audio/computer-hum.mp3',
                new THREE.Vector3(-1.0368, 3.4505, -2.2477), // 显示器位置
                {
                    loop: true,
                    volume: 0.2,
                    refDistance: 2,
                    maxDistance: 10,
                    rolloffFactor: 2
                }
            );

            // 在房间角落添加环境音效
            await this.audioManager.createPositionalAudio(
                'room-ambience',
                '/audio/room-ambience.mp3',
                new THREE.Vector3(0, 2, 0), // 房间中心
                {
                    loop: true,
                    volume: 0.1,
                    refDistance: 5,
                    maxDistance: 20
                }
            );

            // 播放定位音频
            this.audioManager.playPositionalAudio('computer-hum');
            this.audioManager.playPositionalAudio('room-ambience');

        } catch (error) {
            console.error('Failed to setup positional audio:', error);
        }
    }

    showPlayButton() {
        const playButton = document.createElement('button');
        playButton.innerHTML = `
            <img src="/volume.png" alt="Play" style="width: 24px; height: 24px; vertical-align: middle;">
        `
        playButton.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            padding: 12px 24px;
            background: white;
            select: none;
            border-radius: 8px;
            cursor: pointer;
            font-family: Arial, sans-serif;
            font-size: 14px;
            z-index: 1000;
            transition: all 0.3s ease;
        `;

        playButton.addEventListener('click',  () => {

            if (this.audioManager.isPaused) {
                console.log('Resuming ambient music...');
                this.audioManager.resumeAmbientMusic();
                playButton.innerHTML = `
                        <img src="/volume.png" alt="Pause" style="width: 24px; height: 24px; vertical-align: middle;">
                    `;

            }else {
                this.audioManager.stopAmbientMusic();
                playButton.innerHTML = `
                        <img src="/volume-mute.png" alt="Play" style="width: 24px; height: 24px; vertical-align: middle;">
                    `;
            }

        });

        document.body.appendChild(playButton);
    }
    //触发resize事件时更新camera和renderer
    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        // this.stats.begin(); // 开始性能监控
        this.camera && this.camera.update();
        this.world && this.world.update();
        this.renderer && this.renderer.update();

        this.postProcessor && this.postProcessor.update();
        // this.stats.end(); // 结束性能监控
    }


}